<template>
    <b-nav-item-dropdown right no-caret>
        <template slot="button-content">
            <abbr :title="user.email" v-if="user && user.id">
                <button type="button" class="btn btn-light" v-if="logoutLoadStatus == 1">
                    <div class="text-center text-info">
                        <b-spinner small></b-spinner>
                    </div>
                </button>
                <button type="button" class="btn btn-light" v-else><i class="fa fa-user" /> Account</button>
            </abbr>
        </template>
        <b-dropdown-header tag="div" class="text-center" v-if="user && user.id">
            <strong>{{ user.email }}</strong>
        </b-dropdown-header>
        <b-dropdown-item @click="$router.push({ name: 'UserInfo' })">
            <i class="fa fa-info" /> Information
        </b-dropdown-item>
        <b-dropdown-item @click="logout()">
            <i class="fa fa-sign-out" /> Logout
        </b-dropdown-item>
    </b-nav-item-dropdown>
</template>

<script>
import AuthAPI from '../../../../api/auth.js'

export default {
    name: 'HeaderDropdown',
    data: () => {
        return {
            logoutLoadStatus: 0,
        }
    },
    props: {
        user: {
            type: Object,
        },
    },
    methods: {
        logout () {
            var vm = this
            vm.logoutLoadStatus = 1
            AuthAPI.logout()
            .then(response => {
                vm.$store.dispatch('user/logout')
                vm.logoutLoadStatus = 2
                // vm.$router.push({ name: 'Home' })
            })
            .catch(function(error) {
                vm.logoutLoadStatus = 3
                if (error.response) {
                    // Show message error
                    vm.$snotify.error("Server error")
                } else {
                    vm.$snotify.error("Network error")
                }
            })
        },
    },
}
</script>
